// @flow
import React from 'react';

import type { AlbumType } from 'types/Albums';

import { PAGE_SIZE } from 'components/page/template/PageMedia';

type Props = {
  albums: AlbumType[],
  getSetPage: Function,
  page: number
};

function BottomPages({ albums, getSetPage, page }: Props) {
  const maxPage = Math.ceil(albums.length / PAGE_SIZE);
  const pages = [];

  for (let i = 0; i < maxPage; i++) {
    pages.push(
      <div
        onClick={getSetPage(i)}
        key={i}
        className={`${i === page ? 'selected' : ''} page-item`}
        role="button"
        tabIndex="0"
      >
        {i + 1}
      </div>
    );
  }

  return (
    <div className="bottom-navigation">
      <i onClick={getSetPage(Math.max(page - 1, 0))} className="icon icon-chevron-left" role="button" tabIndex="0" />

      <div className="page-list">{pages}</div>

      <i
        onClick={getSetPage(Math.min(page + 1, maxPage - 1))}
        className="icon icon-chevron-right"
        role="button"
        tabIndex="0"
      />
    </div>
  );
}

export default BottomPages;
